import { Col, Row, Button } from 'reactstrap';
import AdminPage from '../../components/admin/AdminPage';
import MapPicker from '../../components/MapPicker';
import LoadingCard from '../../components/LoadingCard';
import SweetAlert from 'react-bootstrap-sweetalert';
import { useModelNearByPlaceMap } from './hooks/useModelNearByPlaceMap';
import PlaceSearchBar from './components/PlaceSearchBar';

const ModelNearByPlaceMap = () => {
  const {
    isLoading,
    nearByPlace,
    errorAlert,
    sweetAlert,
    alertProps,
    setSweetAlert,
    handleSave,
    handlePlaceSelect,
    callEndpoint,
    token,
  } = useModelNearByPlaceMap();

  const pageName = `Actualizar ubicación de lugar cercano`;
  const pageParentName = `Inversiones`;
  const globalAlertOptions = {
    success: false,
    warning: true,
    onConfirm: () => { },
    title: 'Error',
    text: errorAlert || '',
  };

  if (!nearByPlace)
    return <LoadingCard name={pageName} parent_name={pageParentName} />;

  return (
    <AdminPage
      name={pageName}
      parentName={pageParentName}
      globalAlertOptions={globalAlertOptions}
    >
      {sweetAlert && (
        <SweetAlert {...alertProps}>{alertProps.text || ''}</SweetAlert>
      )}
      <Row>
        <Col md={12} className="mb-3">
          <Button color="primary" onClick={handleSave}>
            Guardar Ubicación
          </Button>
        </Col>
        <Col md={6} className="mb-3">
          <PlaceSearchBar
            isLoading={isLoading}
            onPlaceSelect={handlePlaceSelect}
            callEndpoint={callEndpoint}
            token={token}
          />
        </Col>
        <Col md={12}>
          <MapPicker />
        </Col>
      </Row>
    </AdminPage>
  );
};

export default ModelNearByPlaceMap;
